/*
 * @Descripttion: 
 * @version: 
 * @Author: bbq
 * @Date: 2020-08-17 09:56:43
 * @LastEditors: bbq
 * @LastEditTime: 2021-01-13 13:40:50
 */
import React, { Component } from 'react';
import { ViewModel, config as CONFIG, PubSub } from '@platform/api'

function TableWithAutoFocus(WrappedComponent) {
    return class WithAutoFocus extends Component {
        componentDidMount() {
            let { store } = this.props;
            this.autoFocusToken = PubSub.subscribe('autoFocus', (msg, { data, moduleId, force }) => {
                let el = document.querySelector(`div[${data}="${data}"] [tabindex="0"]`);
                let activeEl = document.activeElement;
                let tableId = `${CONFIG.hotKeyModuleIdPrefix}-${moduleId}`;
                console.log(tableId, activeEl, store);
                if (WithAutoFocus.judgeFocus(el, activeEl, tableId, force)) {
                    ViewModel.shouldAutoFocus = true;
                    el.ncExecuteFocus = true;

                    // 设置一个属性
                    let cellselectorkey = el.getAttribute('cellselectorkey') || '';
                    cellselectorkey = cellselectorkey.split('@') || [];
                    store && cellselectorkey[0] && cellselectorkey[1] && store.setCellProps(cellselectorkey[0], cellselectorkey[1], { autoFocus: true }, false);

                    //如果当点聚焦元素与需要聚焦的元素相同就不执行；
                    !el.contains(activeEl) && el.focus();
                    delete el.ncExecuteFocus;
                    // 直接执行  ie下会有顺序问题
                    setTimeout(() => {
                        ViewModel.shouldAutoFocus = false;
                    }, 100);
                }
            });
        }

        componentWillUnmount() {
            this.autoFocusToken && PubSub.subscribe(this.autoFocusToken);
        }

        /**
         * @desc: 业务中存在新增行时先调用addRow后调用setStatus的方法导致焦点在table的第一个可编辑字段，
         *        而不在新增行的第一个可编辑字段上。
         * @resolve: 聚集时判断table是否包含当前活跃元素且活跃元素的tabIndex不等于-1，如果包含就不去执行autoFocus
         *           当前活跃元素可能是table里的操作列，全选功能里的input元素，如果是这些元素就依旧执行focus方法
         * @param el 需要聚焦的元素
         * @param activeEl 当前活跃的元素
         * @param tableId 区域Id
         * @param force true -> 强制执行
         * @return {boolean}
         */
        static judgeFocus(el, activeEl, tableId, force) {
            let tableEL = document.getElementById(tableId);
            if (el) {
                return activeEl.tabIndex !== -1 && tableEL && !tableEL.contains(activeEl) || force;
            }
        }

        render() {
            return (
                <div
                    id={`${CONFIG.hotKeyModuleIdPrefix}-${this.props.tableId || this.props.name}`}
                >
                    <WrappedComponent
                        {...this.props}
                    />
                </div>

            );
        }
    };
}

export default TableWithAutoFocus;
